/**
 * Wrapper for billing form, mainly to inject <Elements />, which must be done
 * before Stripe inject (which is done in BillingForm)
 */
import React from 'react';
import { Elements } from 'react-stripe-elements';

import BillingFormContainer from './BillingForm/BillingFormContainer';

function BillingFormWrapper({ ...rest }) {
  return (
    <Elements font={[{ cssSrc: 'https://fonts.googleapis.com/css?family=Roboto:400' }]}>
      <BillingFormContainer {...rest} />
    </Elements>
  );
}

export default BillingFormWrapper;
